import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../../../components/forms/input'

const EditRecipeIngredient = (props) => {
  const { item } = props.data
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    setFormValue(item)
  }, [item])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.ingredient_name) {
      setErrorMsg({ingredientNameEmpty: '食材名称不能为空'})
      return false
    }

    if (!formValue.dosage) {
      setErrorMsg({dosageEmpty: '用量不能为空'})
      return false
    }

    axios.post('/admin/user/recipe_ingredient/edit', { 
      recipe_ingredient_oid: formValue.oid,
      dosage: Number(formValue.dosage),
      sort: Number(formValue.sort)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getRecipeIngredientData()
          message.success('修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑食材'
      destroyOnClose={true}
      width='500px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyInput
        id="ingredient_name"
        autoFocus
        disabled
        maxLength={64}
        label='食谱名称'
        value={formValue.ingredient_name}
        onChange={setFormValue}
      />

      <MyInput
        type='number'
        id="dosage"
        required
        label='用量'
        value={formValue.dosage}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
        errorMsg={errorMsg.dosageEmpty}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default EditRecipeIngredient
